module.exports = __webpack_public_path__ + "img/ios.06aa41cc.png";